module.exports = __webpack_public_path__ + "media/components/country-flag/static/vu-977ce57868671a3cabbfe21a5c8f855f.svg";